module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tenantRadioGroup.create-button":"Create Tenant"}}')
  delete Component.options._Ctor
}
